import ActivityWrapper from 'components/activity/ActivityWrapper';
import Conditions from 'components/activity/Conditions';
import { Container } from 'components/activity/Container';
import SubHero from 'components/activity/Hero/SubHero';
import IndexLayout from 'components/layout/index/IndexLayout';
import { NO_PERMISSION } from 'config/constants';
import { DeviceContext } from 'hooks/activityCenter/useDevice';
import { GetServerSideProps } from 'next';
import { useTranslations } from 'next-intl';
import { format } from 'date-fns';
import { getActivityList, isError } from 'services/activity';
import { toServerHeader } from 'utils/helper';
import { NextSeo } from 'next-seo';
import { requireMessages } from 'services/http/requireMessages';
import { getBasisServer } from 'utils/helper';
import { helper } from '@blofin/blofin-utils';
import { getKolActivityState } from 'services/activity';
import { useEffect, useState } from 'react';
import KolImg from 'public/images/kolactivity.png';
import useCurrentLocale from 'hooks/useCurrentLocale';
const { toRedirectNoPermission } = helper;
import { utcToZonedTime } from 'date-fns-tz';

const timestampToUTC = (timestamp: string) => {
  return utcToZonedTime(new Date(timestamp), 'UTC');
};

export default function Home({
  isMobile,
  joined,
  activities,
  isApp,
  isDemoTrading,
}: ActivityList & Record<'isMobile', boolean> & Record<'isApp', boolean> & IsDemoTrading) {
  const t = useTranslations('activity');
  const [kolTempList, setKolTempList] = useState<ActivityItem[]>([]);

  const getData = async () => {
    try {
      const result = await getKolActivityState<{ data: KolActivityState }>();
      if (result.code === 200) {
        const { state, start_time, end_time, current_time } = result.data || {};

        if (state === 0) return;
        if (!(current_time < end_time && current_time > start_time)) return;
        const formatTime = () => {
          return `${format(timestampToUTC(start_time), 'MM/dd/yyyy HH:mm')} - ${format(
            timestampToUTC(end_time),
            'MM/dd/yyyy HH:mm'
          )} (UTC)`;
        };
        setKolTempList([
          {
            activity_id: 1,
            activity_link: '/kol-activity',
            activity_sub_title: t('kolActivityIndexDesc'),
            activity_title: t('kolActivityIndexTittle'),
            banner_link: KolImg.src,
            end_time: Number(end_time),
            start_time: Number(start_time),
            state: 'ON_GOING',
            tags: [],
            type: 'COMPETITION',
            timeLabel: t('initiationPeriod'),
            timeLabelString: formatTime(),
          },
        ]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IndexLayout
      mainClassName="min-h-[calc(100vh-152px-64px)] md:min-h-[calc(100vh-50px-64px)]"
      colorType={1}
      isApp={isApp}
      footerTheme="light"
      isDemoTrading={isDemoTrading}
      isSimpleFooter={!isMobile}
    >
      <NextSeo title={t('pageTitle')} description={t('pageDesc')} />
      <SubHero isMobile={isMobile} />
      <DeviceContext.Provider value={{ isMobile, isApp }}>
        <Container>
          <ActivityWrapper
            title={t('boostYourCommunity')}
            list={kolTempList}
            className="mb-[16px] mt-[16px] md:mb-0 md:mt-[80px]"
          />
          <ActivityWrapper title={t('joined')} list={joined} className="mb-[16px] mt-[16px] md:mb-0 md:mt-[80px]" />
          <ActivityWrapper title={t('activities')} list={activities} className="mt-[16px] md:mt-[80px]" />
          <Conditions />
        </Container>
      </DeviceContext.Provider>
    </IndexLayout>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ req, locale, resolvedUrl }) => {
  const { isApp, isDemoTrading, isPhone } = getBasisServer(req, '', false);

  const result = await getActivityList<ActivityList>(undefined, {
    headers: toServerHeader(req, isDemoTrading, locale),
  });

  if (isError(result) && result.error === NO_PERMISSION) {
    console.log('toRedirectNoPermission', toRedirectNoPermission());
    return toRedirectNoPermission();
  }

  const messages = await requireMessages(['components', 'activity'], locale);
  return {
    props: {
      messages,
      isMobile: isPhone,
      isApp,
      isDemoTrading,
      ...(isError(result) ? { joined: [], activities: [] } : result),
    },
  };
};
